(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-result/assets/react/components/map-interval.js');

'use strict';

const {
  useEffect,
  useMemo,
  useState
} = React;
const {
  getIntervalResultMapHandler
} = svs.lyckoplatsen.components.shared_map;
const {
  overlayResultAtom
} = svs.lyckoplatsen.components.shared_result.jotai.atoms;
const {
  memoFetchResult
} = svs.lyckoplatsen.utils.page_result;
const {
  useSetAtom
} = jotai;
const {
  mapErrorDialogNoRedirect
} = svs.lyckoplatsen.shared_map.utils;
const Button = svs.ui.ReactButton;
const mapId = 'map-interval';
const MapInterval = _ref => {
  let {
    results
  } = _ref;
  const mapHandlerResult = useMemo(() => getIntervalResultMapHandler(), []);
  const intervalResults = results;
  const setOverlayResult = useSetAtom(overlayResultAtom);
  const [showCenterMapButton, setShowCenterMapButton] = useState(false);
  const handleCenterMapClick = () => {
    mapHandlerResult.centerMap();
  };

  useEffect(() => {
    const mapOptions = {
      nodeId: mapId,
      maxZoom: 15,
      minZoom: 4,
      zoomSnap: 0.25,
      zoomAnimation: true,
      errorCallback: mapErrorDialogNoRedirect
    };
    const evtHandlers = {
      intervalPinClicked: async _ref2 => {
        let {
          productId,
          drawNumber
        } = _ref2;
        const result = await memoFetchResult(productId, drawNumber);
        setOverlayResult(result);
      },
      showCenterMapButton: bool => setShowCenterMapButton(bool)
    };
    mapHandlerResult.createMap({
      mapOptions,
      evtHandlers
    });
    mapHandlerResult.fitBoundsSweden();
    return () => mapHandlerResult.removeMap();
  }, [mapHandlerResult, setOverlayResult]);
  useEffect(() => {
    if (intervalResults !== null && intervalResults !== void 0 && intervalResults.length) {
      mapHandlerResult.centerMap();
      mapHandlerResult.showIntervalResult(intervalResults);
      return () => mapHandlerResult.removeIntervalResult();
    }
  }, [mapHandlerResult, intervalResults]);
  return React.createElement("div", {
    className: "result-map result-map-interval lp-result-details"
  }, React.createElement("div", {
    id: mapId,
    style: {
      height: '100%',
      width: '100%'
    }
  }), React.createElement(Button, {
    disabled: !showCenterMapButton,
    className: "lp-btn-center-map ".concat(showCenterMapButton ? '' : 'disable'),
    onClick: handleCenterMapClick
  }, React.createElement("svg", {
    fill: "#fff",
    viewBox: "0 0 112 260",
    enableBackground: "new 0 0 112 260",
    xmlSpace: "preserve",
    role: "img",
    "aria-labelledby": "center-map-icon-title"
  }, React.createElement("title", {
    id: "center-map-icon-title"
  }, "Knappen: Visa hela Sverige"), React.createElement("polygon", {
    points: "109.627,57.925 104.224,46.74 105.859,39.394 95.337,12.782 88.204,10.294 79.555,2 75.692,3.421 73.773,14.085 61.474,11.431 47.872,32.711 50.099,39.583 43.346,52.711 36.308,57.001 34.53,75.864 28.891,85.698 31.094,96.456 20.739,97.191 14.506,109.395 16.426,128.495 14.648,138.661 20.762,145.486 16.592,168.756 8.321,178.827 9.293,184.681 2.373,189.562 2.61,200.179 8.866,203.923 8.843,215.795 18.203,236.838 18.345,255.511 21.497,258 33.037,254.872 35.123,245.014 48.654,244.35 56.758,218.354 57.114,196.648 72.517,186.6 76.617,174.941 66.545,159.609 61.569,159.348 58.607,144.964 61.593,130.888 61.829,125.248 75.811,105.627 87.304,97.001 92.304,86.267 91.593,74.086 96.024,58.636 "
  }))));
};
Object.assign(svs.lyckoplatsen.components.page_result.react.components, {
  MapInterval
});

 })(window);